import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService, } from '@spartacus/core'
import { HttpClient } from '@angular/common/http'
import { MB_PRODUCT_REVIEW_NORMALIZER, MbProductReviewsAdapter } from '../connectors'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductReviewsAdapter implements MbProductReviewsAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http
      .get(this.getEndpoint(productCode, maxCount))
      .pipe(this.converter.pipeable(MB_PRODUCT_REVIEW_NORMALIZER))
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productReviews',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}
